import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import metrics from '@/store/metrics'
import user from './user'
import wallet from './wallet'
import account from './account'
import notification from './notification'
import location from './location'
import calendar from './calendar'
import contact from './contact'
import feedback from './feedback'
import app from './app'
import appConfig from './app-config'
import appOptions from './app-options'
import point from './point'
import proposal from './proposal'
import subscription from './subscription'
import referral from './referral'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    wallet,
    account,
    notification,
    location,
    calendar,
    contact,
    subscription,
    feedback,
    app,
    appConfig,
    appOptions,
    point,
    proposal,
    referral,
    verticalMenu,
    metrics,
    'app-ecommerce': ecommerceStoreModule,
  },
  strict: process.env.DEV,
})
